var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0511 10.4258C8.66258 7.43147 4.57115 9.71719 1.14258 13.2372L8.73115 17.8086",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1485 19.5234C25.1427 23.9119 22.857 28.0033 19.3371 31.4319L14.7656 23.8433",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73047 17.7864L14.7876 23.8436C19.6333 20.9407 25.1419 18.1293 27.6562 15.5236C33.0962 10.0836 29.9419 2.63214 29.9419 2.63214C29.9419 2.63214 22.4905 -0.522148 17.0505 4.91784C14.4448 7.43213 11.6105 12.9636 8.73047 17.7864Z",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0684 12.0493L20.5255 20.5065",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 9.71784C24.6314 9.71784 25.1431 9.20616 25.1431 8.57499C25.1431 7.94381 24.6314 7.43213 24.0003 7.43213C23.3692 7.43213 22.8574 7.94381 22.8574 8.57499C22.8574 9.20616 23.3692 9.71784 24.0003 9.71784Z",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41115 29.0086C7.08544 30.2886 1.14258 31.4315 1.14258 31.4315C1.14258 31.4315 2.28544 25.4886 3.56544 24.1629C3.87931 23.8262 4.25782 23.5561 4.6784 23.3686C5.09897 23.1812 5.55298 23.0804 6.01332 23.0723C6.47369 23.0642 6.93097 23.1489 7.35789 23.3213C7.7848 23.4937 8.17261 23.7503 8.49819 24.0761C8.82374 24.4015 9.08041 24.7894 9.25286 25.2164C9.4253 25.6431 9.50998 26.1005 9.50185 26.5609C9.49373 27.0212 9.39298 27.4751 9.20557 27.8957C9.01819 28.3163 8.748 28.6948 8.41115 29.0086Z",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.574707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoc);
export default __webpack_public_path__ + "static/media/roc.d349e56401b5a03641af1052f21a3897.svg";
export { ForwardRef as ReactComponent };